// /client/src/components/UXContext.js
import React, { createContext, useContext, useState } from "react";

const UXContext = createContext({
  mode: "top",
  setMode: () => {},
  leftPanelOpen: false,
  toggleLeftPanel: () => {},
  setLeftPanelOpen: () => {},
});

export const UXProvider = ({ children }) => {
  // Initial state CLOSED as requested
  const [leftPanelOpen, setLeftPanelOpen] = useState(false);
  const openLeftPanel = () => setLeftPanelOpen(true);
  const closeLeftPanel = () => setLeftPanelOpen(false);
  const toggleLeftPanel = () => setLeftPanelOpen((v) => !v);

  const [mode, setMode] = useState("top");

  return (
    <UXContext.Provider
      value={{
        leftPanelOpen,
        openLeftPanel,
        closeLeftPanel,
        toggleLeftPanel,
        mode,
        setMode,
      }}
    >
      {children}
    </UXContext.Provider>
  );
};

export const useUXContext = () => useContext(UXContext);
